<!-- Generated template for the Deal Details component -->
<ion-header>
  <ion-navbar>
    <ion-title>
      Deal Details
    </ion-title>
  </ion-navbar>
</ion-header>
<ion-content>

  <div *ngIf="isDealFetched">
    <ion-slides pager class="ionic_slides">
      <ion-slide *ngFor="let imageObj of sortedImages">
        <img [src]="imageObj.DealMedia" class="ion_slide_images">
        <!-- <video controls="controls" preload="metadata" autoplay="autoplay" webkit-playsinline="webkit-playsinline" class="videoPlayer">
      <source src="https://www.youtube.com/channel/UC7c8mE90qCtu11z47U0KErg" type="video/mp4" />
     </video> -->
      </ion-slide>
    </ion-slides>

    <ion-card class="ionic_card">
      <ion-card-content>
        <ion-card-title class="ionic_card_title">
          <!-- Save Up To 75% On Prescriptions Not Covered by Insurance, Including Many Pet Medications -->
          {{ dealDetail.DealTitle }}
        </ion-card-title>
        <div text-wrap class="text_center_div">
          <span>{{dealDetail.PartnerName}}</span>
          <button class="favorite_toggle_button" ion-button clear (click)="onToggleFavouriteClick()">
            <img [src]="dealDetail.FavoritePartnerFlag ? 'assets/savingsimg/ic_acgdeal_favorite_active.png' : 'assets/savingsimg/ic_acgdeal_favorite.png'"
            class="favorite_toggle_image">
          </button>
        </div>

        <!-- // three icons manage code start like timer, aaa member offer,distance.. -->
        <ion-row *ngIf="secondDividerVisible && firstDividerVisible" style="height: 50px;">
          <ion-col col-3 *ngIf="firstItemVisible">
            <!-- <ion-icon style="position: absolute;font-size: 2.4em;top: 50%;left: 50%;height: 50%;transform: translate(-50%, -50%);width: 10px;height: 10px;display: block;" [name]="cardFirstIcon"></ion-icon> -->
            <img [src]="cardFirstIcon" class="cardimgbig">
          </ion-col>

          <ion-col col-1 *ngIf="firstDividerVisible">
            <span class="divider"></span>
          </ion-col>

          <ion-col col-3 *ngIf="secondItemVisible">
            <ion-row>
              <img [src]="cardSecondIcon" [ngClass]="{
            'cardimgbigthreeitems': secondIconWidth==48,
            'cardimgsmallthreeitems': secondIconWidth==32}">
            </ion-row>
            <ion-row>
              <p style="position: absolute;top: 100%;display: block;left: 10%; white-space:normal; font-size:9px;">{{cardSecondLabelText}}</p>
            </ion-row>
          </ion-col>

          <ion-col col-1 *ngIf="secondDividerVisible">
            <span class="divider"></span>
          </ion-col>

          <ion-col col-3 *ngIf="thirdItemVisible">
            <ion-row>
              <img [src]="cardThirdIcon" [ngClass]="{
            'cardimgbigthreeitems': thirdIconWidth==48,
            'cardimgsmallthreeitems': thirdIconWidth==32}">
            </ion-row>
            <ion-row>
              <p style="position: absolute;top: 100%;display: block;left: 10%;white-space:normal; font-size:9px;">{{cardThirdLabelText}}</p>
            </ion-row>
          </ion-col>

        </ion-row>

        <ion-row *ngIf="firstDividerVisible && !secondDividerVisible" style="height: 50px;">
          <ion-col col-5 *ngIf="firstItemVisible">
            <img [src]="cardFirstIcon" class="cardimgbig">
          </ion-col>

          <ion-col col-2 *ngIf="firstDividerVisible">
            <span class="divider"></span>
          </ion-col>

          <ion-col col-5 *ngIf="secondItemVisible">
            <ion-row>
              <img [src]="cardSecondIcon" [ngClass]="{
            'cardimgbig': secondIconWidth==48,
            'cardimgsmall': secondIconWidth==32}">
            </ion-row>
            <ion-row>
              <p style="position: absolute;top: 100%;display: block;left: 10%;">{{cardSecondLabelText}}</p>
            </ion-row>
          </ion-col>

          <ion-col col-2 *ngIf="secondDividerVisible">
            <span class="divider"></span>
          </ion-col>

          <ion-col col-5 *ngIf="thirdItemVisible">
            <ion-row>
              <img [src]="cardThirdIcon" [ngClass]="{
            'cardimgbig': thirdIconWidth==48,
            'cardimgsmall': thirdIconWidth==32}">
            </ion-row>
            <ion-row>
              <p style="position: absolute;top: 100%;display: block;left: 10%;">{{cardThirdLabelText}}</p>
            </ion-row>
          </ion-col>

        </ion-row>

        


        <ion-row *ngIf="!firstDividerVisible && secondDividerVisible" style="height: 50px;">
          <ion-col col-5 *ngIf="firstItemVisible">
            <img [src]="cardFirstIcon" class="cardimgbig">
          </ion-col>

          <ion-col col-2 *ngIf="firstDividerVisible">
            <span class="divider"></span>
          </ion-col>

          <ion-col col-5 *ngIf="secondItemVisible">
            <ion-row>
              <img [src]="cardSecondIcon" [ngClass]="{
            'cardimgbig': secondIconWidth==48,
            'cardimgsmall': secondIconWidth==32}">
            </ion-row>
            <ion-row>
              <p style="position: absolute;top: 100%;display: block;left: 10%;">{{cardSecondLabelText}}</p>
            </ion-row>
          </ion-col>

          <ion-col col-2 *ngIf="secondDividerVisible">
            <span class="divider"></span>
          </ion-col>

          <ion-col col-5 *ngIf="thirdItemVisible">
            <ion-row>
              <img [src]="cardThirdIcon" [ngClass]="{
            'cardimgbig': thirdIconWidth==48,
            'cardimgsmall': thirdIconWidth==32}">
            </ion-row>
            <ion-row>
              <p style="position: absolute;top: 100%;display: block;left: 10%;">{{cardThirdLabelText}}</p>
            </ion-row>
          </ion-col>

        </ion-row>



        <ion-row *ngIf="!firstDividerVisible && !secondDividerVisible" style="height: 50px;">
          <ion-col col-12 *ngIf="firstItemVisible">
            <img [src]="cardFirstIcon" class="cardimgbig">
          </ion-col>

          <ion-col col-12 *ngIf="secondItemVisible">
            <ion-row>
              <img [src]="cardSecondIcon" [ngClass]="{
              'cardimgbig': secondIconWidth==48,
              'cardimgsmall': secondIconWidth==32}">
            </ion-row>
            <ion-row>
              <p style="position: absolute;top: 100%;display: block;left: 10%;">{{cardSecondLabelText}}</p>
            </ion-row>
          </ion-col>

          <ion-col col-12 *ngIf="thirdItemVisible">
            <ion-row>
              <img [src]="cardThirdIcon" [ngClass]="{
              'cardimgbig': thirdIconWidth==48,
              'cardimgsmall': thirdIconWidth==32}">
            </ion-row>
            <ion-row>
              <p style="position: absolute;top: 100%;display: block;left: 10%;">{{cardThirdLabelText}}</p>
            </ion-row>
          </ion-col>

        </ion-row>
        <!-- // three icons manage code end -->

        <ion-row style="height: 70px; margin-top: 20px;">
          <ion-col style="top: 20%;" col-2>
            <img [src]="(likeThumbActive==1) ? 'assets/savingsimg/ic_detail_vote_up_active.png' : 'assets/savingsimg/ic_detail_vote_up.png'"
              class="cardimgsmall" (click)="onDealLikeButtonClick()">
          </ion-col>
          <ion-col style="padding: 20px!important;" col-8>
            <span> Show more deals like this</span>
          </ion-col>
          <ion-col style="top: 20%;" col-2>
            <img [src]="(disLikeThumbActive==2) ? 'assets/savingsimg/ic_detail_vote_down_active.png' : 'assets/savingsimg/ic_detail_vote_down.png'"
              class="cardimgsmall" (click)="onDealDisLikeButtonClick()">
          </ion-col>
        </ion-row>

      </ion-card-content>
    </ion-card>

    <h1 style="height: 10px;text-align:left;font-weight: 500;font-size: 2.2rem;" padding>Details</h1>
    <div padding style="line-height: 19px;" innerHTML="{{dealDetail.DealDescriptionText}}"></div>
    <!-- <div id="map_canvas" style="height: 200px;" *ngIf="islocationPresent">
    </div> -->
    <div #map id="map" style="height: 200px;" *ngIf="islocationPresent"></div> 


    <ion-item *ngIf="islocationPresent">
      <img item-left small src="assets/savingsimg/ic_detail_compass.png" style="vertical-align:middle;width:24px;height:24px;" />
      <p color="light" style="color:rgba(0, 82, 153, 1.0); white-space: normal">{{selectedLocationFullAddress}}</p>
      <p color="light" style="color:rgba(0, 82, 153, 1.0)" (click)="onLocationsDirectionsClick()" item-right>Get
        Directions ></p>
    </ion-item>

    <ion-item (click)="shoudOpenLocationList()" *ngIf="islocationPresent">
      <img item-left small src="assets/savingsimg/ic_detail_location.png" style="vertical-align:middle;width:24px;height:24px;" />
      <p color="light" style="color:rgba(0, 82, 153, 1.0)">{{locationButtonTitle}}</p>
    </ion-item>
    <ion-list *ngIf="isVisibleLocations && islocationPresent">
      <ion-item *ngFor="let loc of locations; let i=index" text-wrap (click)="onLocationItemClick(i)">
        <p color="light" style="color:rgba(111, 109, 109, 1.0)"> {{loc.PartnerLocationName}} </p>
        <ion-row>
          <ion-col col-7>
            <p color="light" style="color:rgba(0, 82, 153, 1.0)" (click)="initMap(loc)">{{loc.Address}} {{loc.City}},
              {{loc.State}} </p>
          </ion-col>
          <ion-col col-2 style="padding: 0 0 0 10%;">
            <img item-left small src="assets/savingsimg/ic_detail_location.png" style="vertical-align:middle;width:24px;height:24px;" />
          </ion-col>
          <ion-col col-3>
            <p color="light" style="color:rgba(111, 109, 109, 1.0); margin-top: 5px;">
              {{getParnterLocationDistance(loc)}}</p>
          </ion-col>
        </ion-row>

      </ion-item>
    </ion-list>

    <ion-item no-lines *ngIf="islocationPresent">
      <img small src="assets/savingsimg/ic_detail_phone.png" style="vertical-align:middle;width:24px;height:24px;"
        (click)="onLocationPhoneNumberClick()" *ngIf="selectedLocationPhone" />
      <a [href]="'tel:' + selectedLocationPhone" *ngIf="selectedLocationPhone">
        <span color="light" style="color:rgba(0, 82, 153, 1.0);font-size: 1.4rem;">
          {{selectedLocationPhone}} </span>
      </a>
      <!-- <ion-col col-1 *ngIf="dealDetail.PartnerWebsite"> -->
        <img small src="assets/savingsimg/ic_detail_website.png" style="vertical-align:middle;width:24px;height:24px;"
          *ngIf="dealDetail.PartnerWebsite" />
        <!-- <ion-col col-6 *ngIf="dealDetail.PartnerWebsite"> -->
          <a [href]="dealDetail.PartnerWebsite" *ngIf="dealDetail.PartnerWebsite">
            <span color="light" style="color:rgba(0, 82, 153, 1.0);font-size:1.4rem">{{dealDetail.PartnerWebsite}}</span>
          </a>
    </ion-item>

    <div *ngIf="isContactPresent">
      <span style="text-align:left;font-weight: 500;font-size: 2.2rem;" padding>Contact</span>

      <ion-item no-lines *ngIf="dealDetail.RedemptionPhone">
        <img src="assets/savingsimg/ic_detail_phone.png" item-left style="vertical-align:middle;width:24px;height:24px;" />
        <a [href]="'tel:' + dealDetail.RedemptionPhone">
          <p color="light" style="color:rgba(0, 82, 153, 1.0)">{{dealDetail.RedemptionPhone}}
          </p>
        </a>
      </ion-item>

      <ion-item no-lines *ngIf="dealDetail.PartnerWebsite">
        <img src="assets/savingsimg/ic_detail_website.png" item-left style="vertical-align:middle;width:24px;height:24px;" />
        <p color="light" style="color:rgba(0, 82, 153, 1.0)">
           <a [href]="dealDetail.PartnerWebsite" *ngIf="dealDetail.PartnerWebsite">
            {{dealDetail.PartnerWebsite}}</a>
          </p>
      </ion-item>
    </div>

    <span style="text-align:left;font-weight: 500;font-size: 2.2rem; margin-top: 0%;" padding>Fine print</span>
    <div style="line-height: 19px;" padding>{{dealDetail.FinePrintText}}</div>

    <ion-item no-lines (click)="onBlockParnterButtonClick()">
      <p color="light" style="color:rgba(0, 82, 153, 1.0)">{{blockButtonTitle}}</p>
    </ion-item>
  </div>
</ion-content>

<!-- //can appear redeem offer or book now button -->
<ion-footer>
  <ion-toolbar>
    <button ion-button block (click)="onRedeemOfferClicked()" style="background:#4BB56D">
      <b>{{footerButtonTitle}}</b>
    </button>
  </ion-toolbar>
</ion-footer>